import { render, staticRenderFns } from "./PageSectionContainer.vue?vue&type=template&id=04cae98a&"
import script from "./PageSectionContainer.vue?vue&type=script&lang=js&"
export * from "./PageSectionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports